import { Component, OnDestroy, AfterViewInit, Output, EventEmitter, ElementRef, Input } from '@angular/core';

@Component({
    selector: 'ngx-tiny-mce',
    template: '',
})
export class TinyMCEComponent implements OnDestroy, AfterViewInit {

    @Input()
    ngModel: any;

    @Output()
    ngModelChange = new EventEmitter<string>();

    @Output()
    onChange = new EventEmitter<any>();

    editor: any;

    constructor(private host: ElementRef) { }

    ngAfterViewInit() {
        tinymce.init({
            target: this.host.nativeElement,
            plugins: ['link', 'paste', 'table'],
            skin_url: 'assets/skins/lightgray',
            setup: editor => {
                this.editor = editor;
                editor.on('keyup', () => {
                    this.onChange.emit(editor.getContent());
                });
            },
            height: '320',
        });

        this.editor.setContent(this.ngModel);
    }

    ngOnDestroy() {
        tinymce.remove(this.editor);
    }
}
